<section class="content">
    <div class="container-fluid pl-0 pr-0">
        <div class="block-header">
            <div class="row">
                <div class="col-12 mt-2">
                    <mat-button-toggle-group aria-label="Font Style" class="" (change)="changeButtonToggle($event)" [value]="selectedOption">
                        <mat-button-toggle value="schedule">Schedule</mat-button-toggle>
                        <mat-button-toggle value="docset">Document Set</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </div>
        <div [hidden]="!isScheduleDef">
            <div class="row">
                <div class="col-12 mt-3">
                    <dynamic-form #schDefForm [repeatCount]=4 name="schDef">
                    </dynamic-form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="text-right eip-mt-10">
                        <button *ngIf="isAllowEdit || selectedOption != 'schedule' " (click)="saveScheduleDefintion()" class="btn btn-primary" type="submit" [disabled]="schDefFormComponent && schDefFormComponent.value && !schDefFormComponent.value.valid"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button> &nbsp;
                        <button (click)="cancelScheduleDefintion()" class="btn btn-secondary" type="submit"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-3">
                    <kendo-grid [kendoGridBinding]="schDefList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [filterable]="enableFilter" [pageSize]="15" [pageable]="true" id="grvEDMSchDefList" [height]="540">
                        <ng-template kendoPagerTemplate>
                            <div class="k-pager-left">
                                <kendo-pager-info></kendo-pager-info>
                            </div>
                            <div class="k-pager-right">
                                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                <kendo-pager-input></kendo-pager-input>
                                <kendo-pager-next-buttons></kendo-pager-next-buttons>
                            </div>
                        </ng-template>
                        <ng-template kendoGridToolbarTemplate>
                            <div class="k-grid-toolbar-content d-flex">
                                <div class="flex-grow-1 mat-panel-headerbar"></div>
                                <div class="pagination-container">
                                    <p id="lblShowDetails">Show</p>
                                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                    </kendo-pager-page-sizes>
                                    <span>Items</span>
                                </div>
                                <div class="divider-container d-none d-md-block" id="imgDivider">
                                    <span></span>
                                </div>
                                <div class="icons-container">
                                    <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                                    <div class="icon-wrap">
                                        <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                    </div>
                                    <div class="divider-container d-none d-md-block" id="imgDivider">
                                        <span></span>
                                    </div>
                                    <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                        <div class="icon-wrap" (click)="downloadSchDefExcelTemplate()">
                                            <i class="fa fa-file-excel-download-o" aria-hidden="true" id="ibtExcelImport" title="Download Excel"></i>
                                            <span class="list-icon-name">Excel Download</span>
                                        </div>
                                        <div class="icon-wrap">
                                            <input type="file" #excelSchDefUpload [accept]="acceptFileTypes" id="upload-file" placeholder="Choose file" (change)="uploadSchDefTemplate($event)" style="display:none;">
                                            <a (click)="uploadSchDefClick()" href="javascript:undefined">
                                                <i class="fa fa-file-excel-upload-o" aria-hidden="true" id="ibtExcelImport" title="Upload Excel"></i>
                                            </a>
                                            <span class="list-icon-name">Excel Upload</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                {{rowIndex+1}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Structure / Package Name" field="deD_Description" [width]="200">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span class="no-wrap" eipTooltip="{{dataItem.deD_Description}}" eipTooltipPosition="auto">{{dataItem.deD_Description}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Structure / Package No" field="deD_Short_Description" [width]="200">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span class="no-wrap" eipTooltip="{{dataItem.deD_Short_Description}}" eipTooltipPosition="auto">{{dataItem.deD_Short_Description}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="No of Documents" field="number_Of_Docs" [width]="150">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span class="no-wrap" eipTooltip="{{dataItem.number_Of_Docs}}" eipTooltipPosition="auto">{{dataItem.number_Of_Docs}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngFor="let stage of stageConfig" title="{{stage.label}}" [width]="150" filter=false>
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                <span class="no-wrap" eipTooltip="{{getDateRange(dataItem,stage)}}" eipTooltipPosition="auto">{{getDate(dataItem,stage)}}</span>                            
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Action" [width]="80">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                <button *ngIf="isAllowEdit" kendoGridEditCommand class="k-grid-add-command">
                                    <i class="fa fa-pencil" style="font-size: 1.25em; cursor: pointer;" title="Edit" id="" aria-hidden="true" (click)="editSchDef(dataItem)"></i>
                                </button>
                                <span *ngIf="isAllowEdit" kendoGridRemoveCommand class="setSaveIcon">
                                    <i class="fa fa-trash" style="font-size: 1.25em; cursor: pointer;" title="Delete" (click)="deleteSchDef(dataItem)" aria-hidden="true"></i>
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
        <div [hidden]="isScheduleDef">
            <div class="row">
                <div class="col-12 mt-3">
                    <dynamic-form #docSetForm [repeatCount]=4 name="docSet">
                    </dynamic-form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="text-right eip-mt-10">
                        <button (click)="saveDocSet()" class="btn btn-primary btn-sm" type="submit" [disabled]="docSetFormComponent && docSetFormComponent.value && !docSetFormComponent.value.valid"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>&nbsp;
                        <button (click)="cancelDocSet()" class="btn btn-secondary btn-sm" type="submit"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-3">
                    <kendo-grid [kendoGridBinding]="docSetList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMDocSetList" [height]="540">
                        <ng-template kendoPagerTemplate>
                            <div class="k-pager-left">
                                <kendo-pager-info></kendo-pager-info>
                            </div>
                            <div class="k-pager-right">
                                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                <kendo-pager-input></kendo-pager-input>
                                <kendo-pager-next-buttons></kendo-pager-next-buttons>
                            </div>
                        </ng-template>
                        <ng-template kendoGridToolbarTemplate>
                            <div class="k-grid-toolbar-content d-flex">
                                <div class="flex-grow-1 mat-panel-headerbar"></div>
                                <div class="pagination-container">
                                    <p id="lblShowDetails">Show</p>
                                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                    </kendo-pager-page-sizes>
                                    <span>Items</span>
                                </div>
                                <div class="divider-container d-none d-md-block" id="imgDivider">
                                    <span></span>
                                </div>
                                <div class="icons-container">
                                    <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                                    <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                        <div class="icon-wrap">
                                            <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                        </div>
                                        <div class="divider-container d-none d-md-block" id="imgDivider">
                                            <span></span>
                                        </div>
                                        <div class="icon-wrap" (click)="downloadDocSetExcelTemplate()">
                                            <i class="fa fa-file-excel-download-o" aria-hidden="true" id="ibtExcelImport" title="Download Excel"></i>
                                            <span class="list-icon-name">Excel Download</span>
                                        </div>
                                        <div class="icon-wrap">
                                            <input type="file" #excelDocSetUpload [accept]="acceptFileTypes" id="upload-file" placeholder="Choose file" (change)="uploadDocSetTemplate($event)" style="display:none;">
                                            <a (click)="uploadDocSetClick()" href="javascript:undefined">
                                                <i class="fa fa-file-excel-upload-o" aria-hidden="true" id="ibtExcelImport" title="Upload Excel"></i>
                                            </a>
                                            <span class="list-icon-name">Excel Upload</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                {{rowIndex+1}}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Discipline" field="disciplineDesc" [width]="200">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span class="no-wrap" eipTooltip="{{dataItem.disciplineDesc}}" eipTooltipPosition="auto">{{dataItem.disciplineDesc}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Structure / Package" field="structureDesc" [width]="200">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span class="no-wrap" eipTooltip="{{dataItem.structureDesc}}" eipTooltipPosition="auto">{{dataItem.structureDesc}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Document Set" field="document_Set_Name" [width]="200">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span class="no-wrap" eipTooltip="{{dataItem.document_Set_Name}}" eipTooltipPosition="auto">{{dataItem.document_Set_Name}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="No of Documents" field="number_Of_Docs" [width]="150">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span class="no-wrap" eipTooltip="{{dataItem.number_Of_Docs}}" eipTooltipPosition="auto">{{dataItem.number_Of_Docs}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column *ngFor="let stage of stageConfig" title="{{stage.label}}" filter=false [width]="150">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                <span class="no-wrap" eipTooltip="{{getDocSetDateRange(dataItem,stage)}}" eipTooltipPosition="auto">{{getDocSetDate(dataItem,stage)}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Action" [width]="80">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                <button kendoGridEditCommand class="k-grid-add-command" *ngIf="!dataItem.doc_Linked">
                                    <i class="fa fa-pencil" title="Edit" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true" (click)="editDocSet(dataItem)"></i>
                                </button>
                                <span class="setSaveIcon" *ngIf="dataItem.doc_Linked">
                                    <i class="fa fa-repeat" title="Revise" style="font-size: 1.25em; cursor: pointer;" (click)="reviseDocSet(dataItem)" aria-hidden="true"></i>
                                </span>
                                <span kendoGridRemoveCommand class="setSaveIcon" *ngIf="!dataItem.doc_Linked">
                                    <i class="fa fa-trash" title="Delete" style="font-size: 1.25em; cursor: pointer;" (click)="deleteDocSet(dataItem)" aria-hidden="true"></i>
                                </span>                               
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
    </div>
</section>